import { ControlsToggleExtraContent, LayoutComponents } from "@jelly/lesson";
import config from "appConfig";

export const components: LayoutComponents = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 1,
        rows: 4,
        rowsSize: [0, 4, 1, 0],
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/09/principle/separator.svg`,
                    viewType: "cover",
                  },
                },
                styles: {
                  height: "1px",
                  margin: "2%",
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/09/principle/tone-to-noise-ratio-narrow-band.svg`,
                  },
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "badge",
                  options: {
                    items: ["11,05 dB @ 4000 Hz"],
                  },
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/09/principle/separator.svg`,
                    viewType: "cover",
                  },
                },
                styles: {
                  height: "1px",
                  margin: "2%",
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export const extraContent: ControlsToggleExtraContent = [
  {
    type: "audioButton",
    options: {
      icon: "cis-volume-high",
      shape: "round",
      theme: "primary",
      url: `${config.ASSETS_URL}/02/09/principle/narrow-band.wav`,
    },
  },
];
